<template>
	<table class="table-main pdt-list">
		<thead>
			<tr>
				<th
					v-for="item in thList"
					:key="item.id"
					:class="`pdt-list__item--${item.id}`"
					v-text="item.text"
				/>
			</tr>
		</thead>
		<tbody>
			<tr v-for="itemList in list" :key="itemList[0].conts">
				<td
					v-for="item in itemList"
					:key="item.id"
					:class="`pdt-list__item--${item.id}`"
				>
					<img v-if="item.src" :src="item.src" />
					<template v-else>{{ item.conts }}</template>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
	import { getImagePath } from '@/util';
	export default {
		name: 'CastPdtList',
		data() {
			return {
				thList: [
					{
						id: 'id',
						text: '제품항번',
					},
					{
						id: 'img',
						text: '이미지',
					},
					{
						id: 'brand',
						text: '브랜드명',
					},
					{
						id: 'name',
						text: '제품명',
					},
					{
						id: 'display',
						text: '노출',
					},
					{
						id: 'discontinue',
						text: '단종',
					},
				],
				list: [],
			};
		},
		computed: {
			id() {
				return this.$store.state.modal.params.id;
			},
		},
		methods: {
			async setTable() {
				try {
					const {
						data: {
							moduleProductList,
							moduleProductsInfo,
							products,
						},
					} = await this.$axiosNoah.get(`/pouch/${this.id}`);
					this.list = (moduleProductList || products).map(item => {
						if (typeof item === 'number')
							item = moduleProductsInfo[item];
						return [
							{ id: this.thList[0].id, conts: item.idProduct },
							{
								id: this.thList[1].id,
								src:
									item.filePath ||
									getImagePath(
										item.fileDir,
										item.fileSaveName
									),
							},
							{ id: this.thList[2].id, conts: item.brandTitle },
							{ id: this.thList[3].id, conts: item.productTitle },
							{
								id: this.thList[4].id,
								conts: item.isDisplay ? '노출' : '미노출',
							},
							{
								id: this.thList[5].id,
								conts: item.isDiscontinue ? '단종' : '미단종',
							},
						];
					});
				} catch (err) {
					console.error(err);
					alert('첨부된 제품 리스트를 불러오는데 실패했습니다.');
				}
			},
		},
		mounted() {
			this.setTable();
		},
	};
</script>
<style lang="scss" scoped>
	.pdt-list {
		margin-top: 12px;
		table-layout: fixed;

		&__item--id {
			width: 80px;
			padding: 0;
		}

		&__item--img {
			width: 80px;
			padding: 0;
		}

		&__item--display {
			width: 80px;
			padding: 0;
		}

		&__item--discontinue {
			width: 80px;
			padding: 0;
		}
	}
</style>
